import { Providers } from '@or-sdk/providers';
import { IDW_PROVIDER_NAME_SPACE } from '../constants';
export class BaseApi {
    constructor({ providerAccountId, emUrl, token, idwProviderNameSpace = IDW_PROVIDER_NAME_SPACE, discoveryUrl, }) {
        this.providers = new Providers({
            token,
            eventManagerUrl: emUrl,
            providersAccountId: providerAccountId,
            discoveryUrl,
        });
        this.idwProviderNameSpace = idwProviderNameSpace;
    }
    buildRoute(route) {
        return `${this.idwProviderNameSpace}/${route}`;
    }
}
//# sourceMappingURL=BaseApi.js.map